/**
 * 税率
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/tax_rate`

 const search_tax_rate = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     /**
      * 金融機関情報の取得.
      * @param commit
      * @param { String } id コード
      * @return {Promise<unknown>}
      */
     show ({ commit }, { target_date }) {
       const params = { target_date: target_date }
       return new Promise((resolve) => {
         Vue.$http.get(API_PATH, { params: params }).then(data => {
           resolve(data.content)
         })
       })
     },
   },
   mutations: {},
 }
 export default search_tax_rate
